// extracted by mini-css-extract-plugin
module.exports = {"listWrapper":"cultures-list_listWrapper__mx9Fs"};